// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/class/doorFrame1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../images/class/doorFrame2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/HVD_Poster.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.door {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	width: '250px';
	transition: 0.5s;
}

.door:hover {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	width: '270px';
}

.hide {
	transition: 0.01s;
	transform: translateX(-9999px);
}

.classLabel {
	font-family: 'HVDPoster';
}

@font-face {
	font-family: 'HVDPoster'; /*Can be any text*/
	src: local('HVD_Poster'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

.classnav {
	display: flex;
	flex-wrap: nowrap !important;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none; }

.classnav-tabs {
	border-bottom: 1px solid #ffffff;

}
.classnav-tabs .nav-link {
	margin-bottom: -1px;
	background: none;
	border: 1px solid transparent;
	border-top-left-radius: 0.625rem;
	border-top-right-radius: 0.625rem;
	font-size: 1.6dvw;
}
.classnav-tabs .nav-link:hover,
.classnav-tabs .nav-link:focus {
	border-color: #e9ecef #e9ecef #dee2e6;
	isolation: isolate;
}
.classnav-tabs .nav-link.disabled {
	color: #6c757d;
	background-color: transparent;
	border-color: transparent;
}
.classnav-tabs .nav-link.active,
.classnav-tabs .nav-item.show .nav-link {
	color: #495057;
	background-color: #e6ebee;
	border-color: #dee2e6 #dee2e6 #e6ebee;
}
.classnav-tabs .dropdown-menu {
	margin-top: -1px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.class-tabs {
	/* border-bottom: 2px solid #ffffff; */
}
.class-tabs .nav-item .nav-link {
	position: relative;
	color: #ffffff;
}
.class-tabs .nav-item .nav-link:after {
	content: '';
	position: absolute;
	background-color: var(--primary);
	width: 0px;
	height: 2px;
	bottom: -2px;
	left: 0px;
}
.class-tabs .nav-item .nav-link.active {
	background-color: unset;
	border: 1px solid transparent;
	color: var(--primary);
}
.class-tabs .nav-item .nav-link.active:after {
	width: 100%;
}
.class-tabs .nav-item .nav-link:hover {
	border: 1px solid transparent;
}
/* @media only screen and (max-width: 35.9375rem) {
	.class-tabs .nav-item .nav-link {
		padding: 12px;
	}
} */
`, "",{"version":3,"sources":["webpack://./src/jsx/components/Class/style/class.css"],"names":[],"mappings":"AAAA;CACC,mDAA0D;CAC1D,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,mDAA0D;CAC1D,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,wBAAwB,EAAE,kBAAkB;CAC5C,oFAA2E;AAC5E;;AAEA;CACC,aAAa;CACb,4BAA4B;CAC5B,eAAe;CACf,gBAAgB;CAChB,gBAAgB,EAAE;;AAEnB;CACC,gCAAgC;;AAEjC;AACA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,6BAA6B;CAC7B,gCAAgC;CAChC,iCAAiC;CACjC,iBAAiB;AAClB;AACA;;CAEC,qCAAqC;CACrC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,yBAAyB;AAC1B;AACA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qCAAqC;AACtC;AACA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,SAAS;AACV;AACA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;AACA;CACC,6BAA6B;AAC9B;AACA;;;;GAIG","sourcesContent":[".door {\n\tbackground: url('../../../../images/class/doorFrame1.svg');\n\twidth: '250px';\n\ttransition: 0.5s;\n}\n\n.door:hover {\n\tbackground: url('../../../../images/class/doorFrame2.svg');\n\twidth: '270px';\n}\n\n.hide {\n\ttransition: 0.01s;\n\ttransform: translateX(-9999px);\n}\n\n.classLabel {\n\tfont-family: 'HVDPoster';\n}\n\n@font-face {\n\tfont-family: 'HVDPoster'; /*Can be any text*/\n\tsrc: local('HVD_Poster'), url('../fonts/HVD_Poster.ttf') format('truetype');\n}\n\n.classnav {\n\tdisplay: flex;\n\tflex-wrap: nowrap !important;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tlist-style: none; }\n\n.classnav-tabs {\n\tborder-bottom: 1px solid #ffffff;\n\n}\n.classnav-tabs .nav-link {\n\tmargin-bottom: -1px;\n\tbackground: none;\n\tborder: 1px solid transparent;\n\tborder-top-left-radius: 0.625rem;\n\tborder-top-right-radius: 0.625rem;\n\tfont-size: 1.6dvw;\n}\n.classnav-tabs .nav-link:hover,\n.classnav-tabs .nav-link:focus {\n\tborder-color: #e9ecef #e9ecef #dee2e6;\n\tisolation: isolate;\n}\n.classnav-tabs .nav-link.disabled {\n\tcolor: #6c757d;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n}\n.classnav-tabs .nav-link.active,\n.classnav-tabs .nav-item.show .nav-link {\n\tcolor: #495057;\n\tbackground-color: #e6ebee;\n\tborder-color: #dee2e6 #dee2e6 #e6ebee;\n}\n.classnav-tabs .dropdown-menu {\n\tmargin-top: -1px;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.class-tabs {\n\t/* border-bottom: 2px solid #ffffff; */\n}\n.class-tabs .nav-item .nav-link {\n\tposition: relative;\n\tcolor: #ffffff;\n}\n.class-tabs .nav-item .nav-link:after {\n\tcontent: '';\n\tposition: absolute;\n\tbackground-color: var(--primary);\n\twidth: 0px;\n\theight: 2px;\n\tbottom: -2px;\n\tleft: 0px;\n}\n.class-tabs .nav-item .nav-link.active {\n\tbackground-color: unset;\n\tborder: 1px solid transparent;\n\tcolor: var(--primary);\n}\n.class-tabs .nav-item .nav-link.active:after {\n\twidth: 100%;\n}\n.class-tabs .nav-item .nav-link:hover {\n\tborder: 1px solid transparent;\n}\n/* @media only screen and (max-width: 35.9375rem) {\n\t.class-tabs .nav-item .nav-link {\n\t\tpadding: 12px;\n\t}\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
